import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import Callout from "frontcore/components/Callout.vue"
import useLicenceExpirationConfiguration from "frontcore/store/configurations/useLicenceExpirationConfiguration"
import { ref } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpirationAlertCallout',
  setup(__props) {

const showExpirationAlert = ref(false)

const { isLicenceActive, licenceExpirationMessage } =
  useLicenceExpirationConfiguration()

showExpirationAlert.value = !isLicenceActive

const onCloseAlert = () => {
  showExpirationAlert.value = false
}

return (_ctx: any,_cache: any) => {
  return (showExpirationAlert.value)
    ? (_openBlock(), _createBlock(Callout, {
        key: 0,
        showCloseButton: true,
        "data-test": "callout-expiration-alert",
        class: "licence-expiration-alert",
        severity: "warning",
        onCloseCallout: onCloseAlert
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(licenceExpirationMessage)), 1)
        ], undefined, true),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})